import * as X from "@/ui";

import GlobalRatingImage from "./assets/rating-global.svg";
import SourceAppleImage from "./assets/rating-source-apple.svg";
import SourceGoogleImage from "./assets/rating-source-google.svg";
import SourceTrustpilotImage from "./assets/rating-source-trustpilot.svg";


const data = {
  sources: [
    { name: "App Store", image: SourceAppleImage, rating: 4.8 },
    { name: "Play Store", image: SourceGoogleImage, rating: 4.6 },
    { name: "Trustpilot", image: SourceTrustpilotImage, rating: 4.5 },
  ],
};


export function AppRatings(_props: X.PageProps) {
  const tr = X.useTranslator();

  const { decimalSeparator } = X.useNumberFormat();

  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-row gap-2 mb-8">
        <X.Image src={GlobalRatingImage} alt="Global Rating" className="h-[20px] w-auto" />
      </div>
      <div className="flex gap-6 text-sm">
        {data.sources.map((source, i) => (
          <div key={i} className="flex flex-col items-center">
            <X.Image src={source.image} alt={source.name} className="h-[20px] w-auto" />
            <div className="font-bold text-[14px] xl:text-[18px] mt-2 xl:mt-[6px]">{source.rating.toFixed(1).replace(/\./g, decimalSeparator)}</div>
            <div className="text-[12px] xl:text-[18px] mt-1 xl:mt-0 whitespace-nowrap">{tr({ en: `on ${source.name}`, fr: `sur ${source.name}` })}</div>
          </div>
        ))}
      </div>
    </div>
  );
}


export function useNumberFormat() {
  // ssg
  const [format, setFormat] = X.useState(() => X.getNumberFormat());

  // live
  X.useMountEffect(() => {
    setFormat(X.getNumberFormat());
  });

  return format;
}
